module.exports = __webpack_public_path__ + "static/media/asada-shino.44610137.png";